import { Injectable } from '@angular/core';
import { MdlDialogService } from '@angular-mdl/core';
import { isEmpty, difference } from 'lodash';
import { AudienceRolesStorage } from '../../../form-fields/audience-roles-storage';

@Injectable()
export class UploadConfirmationDialog {

    constructor(
        private readonly dialogService: MdlDialogService,
        private readonly audienceRolesStorage: AudienceRolesStorage
    ) { }

    public async openDialog(audienceRoles: string[]): Promise<void> {
        const confirmationText = await this.getConfirmationText(audienceRoles);

        return this.dialogService.confirm(confirmationText, 'No', 'Yes').toPromise();
    }

    private async getConfirmationText(audienceRoles: string[]): Promise<string> {
        let userText = 'by all users';

        if (!isEmpty(audienceRoles)) {
            const allExternalRoles = (await this.audienceRolesStorage.external.toPromise()).map(x => x.name);
            const rolesDiff = difference(allExternalRoles, audienceRoles);

            if (!isEmpty(rolesDiff)) {
                userText = `only by ${audienceRoles.map(x => x.toLowerCase() + 's').join(', ')}`;
            }
        }

        return `The uploaded documents will be viewable ${userText}. Proceed?`;
    }

}